const workflowActionData = [
    {action: 'Submit', status: ['Rejected', 'Pending'], tag: 'Submit', roles: ['Submitter'], buttons: ['Submit']},
    {action: 'InitialReview', status: 'Under Review', tag: 'Initial Review', roles: ['Reviewer'], buttons: ['Accept', 'Reject']},
    {action: 'FinalReview', status: 'Final Review', tag: 'Final Review', roles: ['CCRM'], buttons: ['Accept', 'Reject']}, 
    {action: 'Payout', status: 'Accepted', tag: 'Export Payout', roles: ['Submitter', 'Admin', 'CCRM', 'Reviewer'], buttons: ['Payout']},
];

module.exports = workflowActionData;